const pl = {
  common: {
    appName: 'ONITSOFT Trucking',
    play: 'Graj',
    playAgain: 'Jeszcze raz',
    home: 'Ekran startowy',
    bookDemo: 'Umów demo',
    back: 'Wróć',
    close: 'Zamknij',
    points: 'punkty',
    pts: 'pkt',
    best: 'Najlepszy',
    today: 'Dzisiaj',
    you: 'Ty',
    rank: 'Miejsce',
    soundOn: 'Dźwięk włączony',
    soundOff: 'Dźwięk wyłączony',
    langPl: 'PL',
    langEn: 'EN',
  },
  start: {
    badge: 'Targowa gra ONITSOFT',
    title: 'Prowadzisz ciężarówkę,',
    titleAccent: 'omijasz problemy spedycji',
    subtitle:
      'Kontrola ITD, korek, zamknięty zjazd, brak CMR i niewypłacalny kontrahent. Jedziesz, dopóki w coś nie wjedziesz — Bobi i Sokar ratują ci trasę.',
    nameLabel: 'Twoje imię',
    namePlaceholder: 'np. Kasia',
    nameError: 'Wpisz imię — od 2 do 24 znaków.',
    startBtn: 'Jedziemy!',
    howTitle: 'Jak grać',
    howLane: 'Przesuń palcem w lewo lub w prawo albo dotknij lewej lub prawej połowy ekranu.',
    howCollect: 'Łap zlecenia za punkty i paliwo, które podbija mnożnik combo.',
    howBobi: 'Bobi przejmuje kierownicę na 5 sekund i omija przeszkody za ciebie.',
    howSokar: 'Sokar czyści trasę przed tobą i podwaja punkty na 8 sekund.',
    privacy: 'Imię zostaje na tym telefonie i służy wyłącznie do podpisania wyniku.',
    boardTitle: 'Najlepsze wyniki dzisiaj',
    boardEmpty: 'Nikt jeszcze nie ruszył. Bądź pierwszy.',
  },
  hud: {
    score: 'Wynik',
    speed: 'km/h',
    combo: 'Combo',
    autopilot: 'Autopilot Bobiego',
    doubled: 'Punkty x2',
  },
  entity: {
    itd: {
      name: 'Kontrola ITD',
      hit: 'Kontrola ITD? Bobi trzyma dokumenty i terminy w porządku 24/7.',
    },
    jam: {
      name: 'Korek',
      hit: 'Korek zjadł okno czasowe? Bobi monitoruje trasę i uprzedza, zanim klient zdąży zadzwonić.',
    },
    closedExit: {
      name: 'Zamknięty zjazd',
      hit: 'Zjazd zamknięty? Sokar przeplanuje trasę i zlecenie, zanim stracisz cały dzień.',
    },
    noCmr: {
      name: 'Brak CMR',
      hit: 'Brak CMR to brak zapłaty. Bobi pilnuje kompletu dokumentów do każdego zlecenia.',
    },
    badPayer: {
      name: 'Niewypłacalny kontrahent',
      hit: 'Niewypłacalny kontrahent? Bobi sprawdza NIP i status VAT, zanim przyjmiesz zlecenie.',
    },
    order: { name: 'Zlecenie' },
    fuel: { name: 'Paliwo' },
    bobi: { name: 'Bobi' },
    sokar: { name: 'Sokar Logistics' },
  },
  bubble: {
    start: 'Ruszamy. Trasa wolna!',
    ready: 'Dotknij ekranu i jedziemy.',
    bobi: 'Autopilot. Ja prowadzę.',
    bobiEnd: 'Oddaję kierownicę. Twoja kolej.',
    sokar: 'Sokar czyści trasę. Punkty x2!',
    nearMiss: 'O włos! Ładny unik.',
    combo: 'Combo rośnie. Tak trzymaj.',
    fast: 'Ale tempo. Oczy na drogę.',
    comboLost: 'Combo przepadło. Łap paliwo.',
  },
  over: {
    title: 'Koniec trasy, {{name}}!',
    titleBest: 'Rekord dnia, {{name}}!',
    crashedBy: 'Zatrzymało cię: {{obstacle}}',
    scoreLabel: 'Twój wynik',
    codeLabel: 'Kod weryfikacyjny',
    codeHint: 'Pokaż ten kod obsłudze stoiska, żeby potwierdzić wynik.',
    rankLabel: 'Miejsce {{rank}} dzisiaj',
    personalBest: 'Twój najlepszy wynik dzisiaj',
    stats: {
      orders: 'Zlecenia',
      fuel: 'Paliwo',
      bobi: 'Bobi',
      sokar: 'Sokar',
      near: 'O włos',
      distance: 'Dystans',
      time: 'Czas',
      topSpeed: 'Maks. prędkość',
    },
    prize: {
      title: 'Nagrody na stoisku',
      desc: 'Najlepsze wyniki dnia nagradzamy na stoisku ONITSOFT — pokaż obsłudze swój wynik i kod weryfikacyjny. Ranking zapisuje się w tym telefonie, więc liczy się to, co pokażesz na miejscu.',
    },
    demo: {
      title: 'Bobi i Sokar na serio',
      desc: 'W grze omijasz te problemy odruchowo — w codziennej spedycji robią to za ciebie Bobi i Sokar Logistics. Umów bezpłatne demo i zobacz to na swoich zleceniach.',
      qrHint: 'Zeskanuj kod telefonem albo zostaw e-mail poniżej.',
      button: 'Umów bezpłatne demo',
    },
    lead: {
      title: 'Wolisz, żebyśmy się odezwali?',
      desc: 'Zostaw e-mail, a umówimy termin demo Bobiego i Sokara. Żadnego newslettera.',
      email: 'E-mail',
      emailPlaceholder: 'imie@firma.pl',
      phone: 'Telefon (opcjonalnie)',
      phonePlaceholder: '+48 600 000 000',
      consent:
        'Wyrażam zgodę na przetwarzanie moich danych osobowych przez Onit Soft sp. z o.o. z siedzibą w Krakowie (administrator danych) w celu kontaktu w sprawie demo Bobiego i Sokar Logistics. Zgodę mogę wycofać w każdej chwili.',
      submit: 'Wyślij',
      sending: 'Wysyłam…',
      sent: 'Dzięki! Odezwiemy się w sprawie demo.',
      queued: 'Brak sieci — wyślemy zgłoszenie, gdy tylko wróci połączenie.',
      error: 'Nie udało się wysłać. Spróbuj jeszcze raz.',
      invalidEmail: 'Podaj poprawny adres e-mail.',
      consentRequired: 'Zaznacz zgodę, żeby wysłać zgłoszenie.',
    },
  },
  verify: {
    title: 'Weryfikacja wyniku',
    subtitle: 'Wpisz kod z telefonu gracza, żeby sprawdzić, czy wynik pochodzi z gry.',
    placeholder: 'TRK-XXXX',
    check: 'Sprawdź',
    valid: 'Kod prawidłowy',
    invalid: 'Kod nieprawidłowy — ten wynik nie pochodzi z gry.',
    scoreLabel: 'Wynik: {{score}} pkt',
  },
}

export default pl

export type Resources = typeof pl
